import {React, Component, _, Modal, Header, Body} from 'utils';
import {Creators} from 'model';
import PropTypes from 'prop-types';
import {FilterOkButton} from 'components';
import './searchfilter.less';

export default class SearchFilter extends Component {

	generateFilters = (name, items, filterClick) =>
	{
		let itemElements = items.map((item, i) =>
		{
			let selectedClass = (item.selected) ? ' selected ' : '';
			let activeClass = (item.active) ? ' active ' : '';
			return (
				<div key={i} className={'col-12 filter-item ' + selectedClass + activeClass} onClick={filterClick}
					 data-filter={name} data-name={item.name} data-index={item.index}>
					{item.name}
				</div>
			);
		});

		let collapseName = 'collapse' + name;

		return (
			<div key={name} className="filter-group">
				<div className="row">
					<div className="col-12 filter-name collapsed" data-toggle="collapse"
						 data-target={'#' + collapseName}>
						{_('Filter ' + name.toLowerCase())}
					</div>
				</div>
				<div className="row collapse" id={collapseName}>
					{itemElements}
				</div>
			</div>
		)
	};

	render()
	{
		var {name, query, loading, data, handleChange, filterClick, removeFilterClick, applyFiltersClick} = this.props;

		var generateFilters = this.generateFilters;
		var tags = [];
		var filterElements = [];

		data.forEach(function (filterElement)
		{
			filterElements.push(generateFilters(filterElement.name, filterElement.items, filterClick));

			filterElement.items.map((item)=>
			{
				if (item.active)
				{
					tags.push(Object.assign(item, {type: filterElement.name}));
				}
			});
		});

		var tagElements = tags.map((item)=>
		{
			return <span key={item.index} className="filters-active-item" onClick={removeFilterClick}
						 data-filter={item.type} data-name={item.name} data-index={item.index}>{item.name}</span>
		});

		var css = ['fa'];

		if (loading)
		{
			css.push('fa-refresh');
		}
		else
		{
			css.push('fa-search');
		}

		if (query === undefined)
		{
			query = '';
		}

		return <div className="search-filter">
			<div className="form-group filters">
				<div className="search-box">
					<input type="text" value={query} onChange={handleChange} className="form-control form-control-lg"/>
					<i className={css.join(' ')}></i>
				</div>

				<button onClick={(e) => Creators.showFilterModal(name)} type="submit"
						className="btn btn-lg btn-primary add-filter">
					<span className="d-none d-md-inline">{_('Add filter')}</span>
					<i className="fa fa-sliders"/>
				</button>

				<Modal show={'show-filters-' + name} hide={'hide-filters-' + name} className="filter-modal right">
					<Header title={_('Filter')}/>
					<Body>
					<div>
						{filterElements}
					</div>
					<FilterOkButton onClick={applyFiltersClick}/>
					</Body>
				</Modal>

			</div>

			<div className="filters-active row no-gutters">
				{tagElements}
			</div>

		</div>
	}
}

SearchFilter.propTypes = {
	name: PropTypes.string.isRequired,
	query: PropTypes.string,
	loading: PropTypes.bool,
	data: PropTypes.array.isRequired,
	handleChange: PropTypes.func.isRequired,
	filterClick: PropTypes.func.isRequired,
	removeFilterClick: PropTypes.func.isRequired,
	applyFiltersClick: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/modules/components/elements/searchfilter.js